export default __webpack_public_path__ + "static/media/arrow_down.438835b8.svg";